import { CompatibleWithApplicationParameter, PartCollectionModel } from "@dana/Handlers/CompatibleWithApplicationHandler";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";


const applicablePartsUrl = "api/v2/dana/applicableParts";

export async function getApplicableParts(parameter: CompatibleWithApplicationParameter) {
const {...newParemeter} = parameter;
    const partsCollectionModel = await get<PartCollectionModel>(`${applicablePartsUrl}`, newParemeter as ApiParameter,{},"no-cache");
   return partsCollectionModel;
}
